import { PerkTile } from '@ahmdigital/ui';
import styled from 'styled-components';

export const PerksContainer = styled.div`
  padding: 4rem 2rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    grid-template-columns: repeat(2, 1fr);
    display: grid;
    gap: 4rem 2rem;
  }

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledPerkTile = styled(PerkTile)`
  max-width: none;

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    max-width: 27rem;
  }

  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: 2rem;
  }
`;
